import { Editor, useEditorState } from '@tiptap/react';
import { FunctionComponent, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BlockToolLabel } from '../BlockToolLabel';

interface ParagraphProps {
  editor: Editor;
}

export const Paragraph: FunctionComponent<ParagraphProps> = ({ editor }) => {
  const { t } = useTranslation();

  const { isActive, isActiveList, isActiveTable } = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isActive: editor.isActive('paragraph'),
      isActiveList:
        editor.isActive('taskList') ||
        editor.isActive('orderedList') ||
        editor.isActive('bulletList'),
      isActiveTable: editor.isActive('table'),
    }),
  });

  const allowed = useMemo(
    () =>
      ['paragraph', 'heading', 'taskList', 'orderedList', 'bulletList'].includes(
        editor.state.selection.$from.node(1)?.type.name
      ),
    [editor.state.selection]
  );

  return (
    <BlockToolLabel
      iconId={'text'}
      hint={t('richTextEditor.tool-names-text')}
      active={isActive && !isActiveList && !isActiveTable}
      disabled={!allowed}
      onClick={() => editor.commands.setParagraph()}
    />
  );
};
